module.exports = __webpack_public_path__ + "static/img/fish45.2acfdf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish45.png
// module id = +3cV
// module chunks = 0